import { Box, CircularProgress } from "@mui/material";
import type { LoadingIndicatorProps } from "stream-chat-react";

const DEFAULT_SIZE = 20;

/**
 * Stream's `LoadingIndicator` slot on `<Channel>` serves two places: the whole panel while an
 * uninitialised channel loads, and the "loading more" row inside EVERY message list — the
 * conversation's and the thread's. The channel-header skeleton used to sit in this slot, so a
 * thread fetching its replies showed a blue bar with an avatar it doesn't have. This is the
 * list-row variant; the header skeleton stays with the panel that renders before a channel exists.
 */
export const ChatListLoadingIndicator = ({
  size = DEFAULT_SIZE,
}: LoadingIndicatorProps) => (
  <Box display="flex" justifyContent="center" py={1}>
    <CircularProgress size={size} />
  </Box>
);
